import { Injectable } from "@angular/core"; 
import { AppConsts } from "../shared/app-consts";  
import { BaseService } from "./base.service";
import * as _ from 'lodash';

@Injectable({
    providedIn: 'root',
})
export class ChartService extends BaseService {
  
  constructor() {
    super();
  }

  getRandomColor():string {
    return _.sample(AppConsts.ChartColors);
  }

  getRandomColorArray(length:number):string[] {
    return _.sampleSize(AppConsts.ChartColors, length);
  }
}